module.exports = __webpack_public_path__ + "media/images/icons/outlined/shopping-cart-f8ce3c4e731f6113f7640ded68b8e58c.svg";